/* eslint max-len: 0 */

import React from 'react';
import Helmet from 'react-helmet';
import styled from 'react-emotion';
import Header from './Header';
import config from '../../config/website';

import SlideUp from './ani/SlideUp';
import Browser from '../util/Browser';

import HandsHelping from '../icons/fa-solid/HandsHelping';

import CenterWrap from './CenterWrap';
import CenterDiv from './CenterDiv';

const DivSVG = styled.div`
  svg {
    width: 40rem;
    height: 40rem;
    opacity: 0.35;
    g {
      fill: ${props => props.theme.colors.cool.dark};
    }
  }
  position: absolute;
  top: -730px;
  left: 100px;
  z-index: 10;
  overflow: hidden;
  max-height: 640px;
  @media (max-width:600px) {
    max-height: 560px;
    left: 0px;
    top: -460px;
    svg { 
      width: 35rem;
      height: 35rem;
  }
`;

let SlideUp00 = styled.div``;
const ContactHeader = () => {
  /*
  if (Browser() === 'chrome') {
    SlideUp00 = SlideUp;
  }
  */
  SlideUp00 = SlideUp;
  return (
    <React.Fragment>
      <Helmet title={`Help | ${config.siteTitle}`} />
      <Header slim title={`${'\u00A0'}:${'\u00A0'}:${'\u00A0'}HELP${'\u00A0'}:${'\u00A0'}:`}>
        Get In Touch / Get It Done
    </Header>
      <SlideUp00 toY="90px" fromX="-90px">
        <CenterWrap>
          <CenterDiv>
            <DivSVG>
              <HandsHelping />
            </DivSVG>
          </CenterDiv>
        </CenterWrap>
      </SlideUp00>
    </React.Fragment>
  );
};
export default ContactHeader;



// WEBPACK FOOTER //
// ./src/components/ContactHeader.jsx